<template>
  <div style="width: 100%; height: 100%">
    <video
      v-if="tempOpen"
      autoplay
      muted
      src="/static/mp4/111.mp4"
      width="100%"
      height="100%"
    ></video>
    <video
      v-else
      ref="el"
      v-loading="dvLoading"
      element-loading-text="视频即将加载完成,请稍等"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      autoplay
      :controls="showControls"
      muted
      width="100%"
      @canplay="canplay"
      :src="ws_stream_url"
    ></video>
  </div>
</template>

<script>
let that;
import config from "@/web.config";
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    showControls: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tempOpen: config.tempOpen,
      ws_stream_url: "",
      pageName: "ar",
      saveIRealHandleStr: "",
      lableInfo: "",
      video_ws: null,
      saveStartTimeAR: null,
      // dvUrl: '',
      socketUrl: "",
      dvLoading: false,
      isOpen: false,
      AR_info: {},
    };
  },
  methods: {
    canplay() {
      this.dvLoading = false;
    },
    closeStream() {
      if (this.video_ws) {
        this.video_ws.close();
        this.video_ws = null;
      }
    },
    getMsg() {
      if (!this.data.streamUrl) {
        return;
      }
      this.socketUrl = this.data.streamUrl;
      this.dvLoading = true;

      this.init_play();
    },
    init_play() {
      if (!Uint8Array.prototype.slice) {
        Object.defineProperty(Uint8Array.prototype, "slice", {
          value: function (begin, end) {
            return new Uint8Array(Array.prototype.slice.call(this, begin, end));
          },
        });
      }

      const verbose = true;
      let streamingStarted = false;
      const ms = new MediaSource();
      const queue = [];
      let sourceBuffer;
      let i = 0;
      function pushPacket(arr) {
        var view = new Uint8Array(arr);
        if (verbose) {
          // console.log(
          //   "got",
          //   arr.byteLength,
          //   "bytes.  Values=",
          //   view[0],
          //   view[1],
          //   view[2],
          //   view[3],
          //   view[4]
          // );
        }
        if (!streamingStarted) {
          //报错sourceBuffer on appendBuffer 这些有关错误，首先开启或关闭 chrome设置的硬件加速，因为硬件不兼容
          //如 This SourceBuffer has been removed from the parent media source
          sourceBuffer.appendBuffer(arr);
          streamingStarted = true;
          return;
        }
        queue.push(arr);
        if (verbose) {
          // console.log('queue push:', queue.length)
        }
        if (!sourceBuffer.updating) {
          loadPacket();
        }
      }

      function loadPacket() {
        // ms.endOfStream();
        if (!sourceBuffer.updating) {
          if (queue.length > 0) {
            const inp = queue.shift();
            if (verbose) {
              // console.log('queue PULL:', queue.length)
            }
            var view = new Uint8Array(inp);
            if (verbose) {
              // console.log('writing buffer with', view[0], view[1], view[2], view[3], view[4])
            }
            sourceBuffer.appendBuffer(inp);
          } else {
            streamingStarted = false;
          }
        }
      }
      let videoElement_ar = that.$refs.el;
      function opened() {
        if (this.video_ws) {
          console.log("已存在ws  先关闭");
          this.closeStream();
          setTimeout(() => {
            opened();
          }, 500);
          return;
        }
        that.video_ws = new WebSocket(that.socketUrl);
        that.video_ws.binaryType = "arraybuffer";
        that.video_ws.onopen = function (event) {
          console.log("打开ws推流Connect");
        };
        that.video_ws.onmessage = function (event) {
          //     if (!that.saveStartTimeAR) {
          //         that.saveStartTimeAR = new Date().getTime(); // 记录第一帧系统时间
          //     }
          //     const startPlayTimeAR = videoElement_ar.currentTime;
          //     const saveNewTimeAR = new Date().getTime();
          //     const sysNowTimeAR = (saveNewTimeAR - that.saveStartTimeAR) / 1000;
          //     console.log(i++,'time----->', sysNowTimeAR - startPlayTimeAR);
          //     if (sysNowTimeAR - startPlayTimeAR > 15) {
          //         that.saveStartTimeAR = null;
          //         that.init_play();
          //     } else if (sysNowTimeAR - startPlayTimeAR > 8) {
          //         that.saveSysNum++;
          //         videoElement_ar.currentTime = 1e101;
          //         videoElement_ar.currentTime = sysNowTimeAR / 1000 - 1
          //     } else if (sysNowTimeAR - startPlayTimeAR > 1.5) {
          //         that.saveSysNum++;
          //         videoElement_ar.playbackRate = 1.2;
          //     } else if (sysNowTimeAR - startPlayTimeAR > 0.6) {
          //         that.saveSysNum = 0; //当快进后会回到低延迟，证明不是卡丢了视频总时长，就算是也是丢了一点点，清0
          //         videoElement_ar.playbackRate = 1.1;
          //     } else {
          //         videoElement_ar.playbackRate = 1.0;
          //     }
          //     if (that.saveSysNum > 600) {
          //         //平均0.5s就加1，那么大于300秒都是视频延迟1.1秒以上，就重新载入视频
          //         that.saveStartTimeAR = null;
          //         that.init_play();
          //     }
          if (!ms || ms.readyState !== "open") return;
          var data = new Uint8Array(event.data);
          if (data[0] === 9) {
            const decoded_arr = data.slice(1);
            let mimeCodec;
            if (window.TextDecoder) {
              mimeCodec = new TextDecoder("utf-8").decode(decoded_arr);
            } else {
              mimeCodec = Utf8ArrayToStr(decoded_arr);
            }
            if (verbose) {
              // console.log('first packet with codec data: ' + mimeCodec)
            }
            sourceBuffer = ms.addSourceBuffer('video/mp4; codecs="' + mimeCodec + '"');
            sourceBuffer.mode = "segments";
            sourceBuffer.addEventListener("updateend", loadPacket);
          } else {
            pushPacket(event.data);
          }
          if (sourceBuffer.updating || queue.length > 0 || config.hadSourceBuffer) {
            /* ---start处理前端延时修正，因为这个方式是将流变成mp4存在内存中，mp4文件由于网页卡，或暂停就会加大延迟，让video直接跳转系统修正的x秒*/
            if (!that.saveStartTimeAR) {
              that.saveStartTimeAR = new Date().getTime(); // 记录第一帧系统时间
            }
            const startPlayTimeAR = videoElement_ar.currentTime;
            const saveNewTimeAR = new Date().getTime();
            const sysNowTimeAR = (saveNewTimeAR - that.saveStartTimeAR) / 1000;
            // console.log(i++, "time----->", sysNowTimeAR - startPlayTimeAR);
            if (sysNowTimeAR - startPlayTimeAR > 15) {
              that.saveStartTimeAR = null;
              that.init_play();
            } else if (sysNowTimeAR - startPlayTimeAR > 8) {
              that.saveSysNum++;
              videoElement_ar.currentTime = 1e101;
              videoElement_ar.currentTime = sysNowTimeAR / 1000 - 1;
            } else if (sysNowTimeAR - startPlayTimeAR > 1.5) {
              that.saveSysNum++;
              videoElement_ar.playbackRate = 1.2;
            } else if (sysNowTimeAR - startPlayTimeAR > 0.6) {
              that.saveSysNum = 0; //当快进后会回到低延迟，证明不是卡丢了视频总时长，就算是也是丢了一点点，清0
              videoElement_ar.playbackRate = 1.1;
            } else {
              videoElement_ar.playbackRate = 1.0;
            }
            if (that.saveSysNum > 600) {
              //平均0.5s就加1，那么大于300秒都是视频延迟1.1秒以上，就重新载入视频
              that.saveStartTimeAR = null;
              that.init_play();
            }
            /* ---end*/
          }
        };
      }

      function Utf8ArrayToStr(array) {
        var out, i, len, c;
        var char2, char3;
        out = "";
        len = array.length;
        i = 0;
        while (i < len) {
          c = array[i++];
          switch (c >> 4) {
            case 7:
              out += String.fromCharCode(c);
              break;
            case 13:
              char2 = array[i++];
              out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
              break;
            case 14:
              char2 = array[i++];
              char3 = array[i++];
              out += String.fromCharCode(
                ((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0)
              );
              break;
          }
        }
        return out;
      }
      function startup() {
        ms.addEventListener("sourceopen", opened, false);
        // that.$refs.el.src = window.URL.createObjectURL(ms);
        that.ws_stream_url = window.URL.createObjectURL(ms);
      }
      that.saveStartTimeAR = null; // 改变播放流时，清空上个视频第一帧，下面会再记录新第一帧时间
      startup();
    },
  },
  mounted() {
    if (!this.tempOpen) this.getMsg();
  },
  created() {
    that = this;
  },
  destroyed() {
    if (this.video_ws) {
      this.closeStream(); // 销毁页面时清除AR视频流 websocket的事件
    }
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/video-ws-stream.vue